import React, { useState } from 'react';
import hero from './bearcat3d6x.png';
import './App.css';
import './Chatbot.css';
import Chatbot from './Chatbot';
import NyxNoCodeStudentGuide from "./NyxNoCodeStudentGuide";
import MissionBearcatsHubOverview from "./MissionBearcatsHubOverview";
import SponsorsMentors from "./SponsorsMentors";
import KuafInterview from "./KUAF_NPR_Trails_at_Mena_Karen_Kilroy_Interview";

function AppContent() {
    const [activeDoc, setActiveDoc] = useState(null); // Track the active document

    const renderActiveDocument = () => {
        switch (activeDoc) {
            case 'KuafInterview':
                return <KuafInterview />;
            case 'NyxNoCodeStudentGuide':
                return <NyxNoCodeStudentGuide />;
            case 'MissionBearcatsHubOverview':
                return <MissionBearcatsHubOverview />;
            case 'SponsorsMentors':
                return <SponsorsMentors />;
            default:
                return null;
        }
    };

    return (
        <div className="app-content">
            <header className="App-header">
                <div className="hero-container">
                    <img src={hero} className="hero-img" alt="Justin" />
                    <div
                        className="scroll-indicator"
                        onClick={() => document.querySelector('.resource-links')?.scrollIntoView({ behavior: 'smooth' })}
                    >
                        <div className="arrow-down">⬇</div>
                    </div>
                </div>

                {/* Display list of links */}
                <div className="resource-links">
                    <h2>Resources</h2>
                    <div>
                        <button onClick={() => setActiveDoc('MissionBearcatsHubOverview')}>Mission: Bearcats Hub Overview</button>
                    </div>
                    <div>
                        <button onClick={() => setActiveDoc('NyxNoCodeStudentGuide')}>NYX NoCode Student Guide</button>
                    </div>
                    <div>
                        <button onClick={() => setActiveDoc('KuafInterview')}>KUAF Reports: Mena NoCode Hackathon</button>
                    </div>
                </div>

                {/* Render the selected document */}
                <div className="documentation-content">
                    {renderActiveDocument()}
                </div>

                <div className="auth-info">
                    <p>Signed in as {process.env.NODE_ENV === 'development' ? "karen@knowbots.org" : "Guest"}</p>
                </div>
                <div className="chat-container">
                    <div className="chat-popup">
                        <div className="response-container">
                            <Chatbot setFilterCriteria={(criteria) => console.log(criteria)} />
                        </div>
                    </div>
                </div>
            </header>
        </div>
    );
}

export default AppContent;
